<template>
  <v-layout row wrap>
    <v-flex
      xs12
      mb-3
    >
      <v-layout row wrap>
        <v-flex
          xs12
          md3
        >
          <span class="ml-1 label">
            {{ $t('message.bizgainOnboarding.summaryPage.Objective') }}:
          </span>
        </v-flex>
        <v-flex
          xs12
          md9
        >
          <v-layout>
            <v-flex xs1>
              <div>
                <img :src="objectiveType.calls.imageUrl" class="imageIcon">
              </div>
            </v-flex>
            <v-flex xs9>
              <span class="label detail-field">
                Get More Calls
              </span>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex
      xs12
      mb-3
    >
      <v-layout row wrap>
        <v-flex
          xs12
          md3
        >
          <span class="ml-1 label">
            {{ $t('message.bizgainOnboarding.summaryPage.MobileNUmber') }}:
          </span>
        </v-flex>
        <v-flex
          xs12
          md9
        >
          <v-layout>
            <v-flex xs1>
              <v-icon class="greyIcon">
                phone
              </v-icon>
            </v-flex>
            <v-flex xs9>
              <span class="ml-1 label detail-field" :class="{'ml-1': $vuetify.breakpoint.xsOnly}">
                {{ mobileNumber }}
              </span>
            </v-flex>
            <v-flex xs2>
              <v-icon class="editIcon" @click="goToSelectObjective()">
                edit
              </v-icon>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex
      xs12
      mb-3
    >
      <v-layout row wrap>
        <v-flex
          xs12
          md3
        >
          <span class="ml-1 label">
            {{ $t('message.bizgainOnboarding.summaryPage.TimeToReceiveCalls') }}:
          </span>
        </v-flex>
        <v-flex
          xs12
          md9
        >
          <v-layout>
            <v-flex xs1>
              <v-icon class="greyIcon">
                phone
              </v-icon>
            </v-flex>
            <v-flex xs9>
              <span class=" label detail-field" :class="{'ml-1': $vuetify.breakpoint.xsOnly}">
                {{ timeToReceiveCalls }}
              </span>
            </v-flex>
            <v-flex
              xs2
              class="editIcon"
            >
              <v-icon class="editIcon" @click="goToSelectObjective()">
                edit
              </v-icon>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex
      xs12
      mb-3
    >
      <v-layout row wrap>
        <v-flex
          xs12
          md3
        >
          <span class="ml-1 label">
            {{ $t('message.bizgainOnboarding.summaryPage.ServicesPromoted') }}:
          </span>
        </v-flex>
        <v-flex
          xs12
          md9
        >
          <v-layout>
            <v-flex xs1>
              <v-icon class="greyIcon">
                home_repair_service
              </v-icon>
            </v-flex>
            <v-flex xs9>
              <span class="label detail-field" :class="{'ml-1': $vuetify.breakpoint.xsOnly}">
                {{ selectedServices }}
              </span>
            </v-flex>
            <v-flex xs2>
              <v-icon class="editIcon" @click="goToPromoteServices()">
                edit
              </v-icon>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex
      xs12
      mb-1
    >
      <v-layout row wrap>
        <v-flex
          xs12
          md3
        >
          <span class="ml-1 label">
            {{ $t('message.bizgainOnboarding.summaryPage.PromotionTag') }}:
          </span>
        </v-flex>
        <v-flex
          xs12
          md9
        >
          <v-layout>
            <v-flex xs1>
              <v-icon class="greyIcon">
                local_offer
              </v-icon>
            </v-flex>
            <v-flex xs9>
              <span class="label detail-field" :class="{'ml-1': $vuetify.breakpoint.xsOnly}">
                {{ offerTagline }}
              </span>
            </v-flex>
            <v-flex xs2>
              <v-icon class="editIcon" @click="goToOfferDetails()">
                edit
              </v-icon>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import {
  VLayout,
  VFlex,
  VIcon
} from 'vuetify/lib';
import { objectiveType, weekDays, bizgainOnboardingRoutes }  from 'Features/bizgainOnboarding/constants';

export default {
  components: {
    VLayout,
    VFlex,
    VIcon
  },
  props: [
    'mobileNumber',
    'callHours',
    'selectedServices',
    'offerTagline'
  ],
  data() {
    return {
      objectiveType,
      weekDays,
      bizgainOnboardingRoutes
    }
  },
  computed: {
    timeToReceiveCalls(){
      let days = [];
      let openingTime = null;
      let closingTime = null;
      let timings = '';
      for(let callHour of this.callHours){
        days.push(this.weekDays[callHour.dayOfWeek].name);
        if(callHour && !openingTime && !closingTime){
          openingTime = new Date(callHour.openingTime);
          closingTime = new Date(callHour.closingTime);
          timings = openingTime.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }) +  ' to ' +
          closingTime.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
        }
      }
      return days.join(', ') + ' ' + timings;
    }
  },
  methods: {
    goToSelectObjective(){
      this.$router.push({ name: bizgainOnboardingRoutes.SelectObjective.name, params: { isAppFlow: true, summary: true } });
    },
    goToPromoteServices(){
      this.$router.push({ name: this.bizgainOnboardingRoutes.PromoteServices.name, params: { isAppFlow: true } });
    },
    goToOfferDetails(){
      this.$router.push({ name: this.bizgainOnboardingRoutes.ExtractOfferDetails.name, params: { isAppFlow: true } });
    }
  }
}
</script>
<style lang="scss" scoped>
.greyIcon{
  color: #727891;
}
.editIcon{
  color: #13abb1;
}
.imageIcon{
  height: 28px;
  width: 28px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.detail-field{
  color: black;
  align-self: center;
}
@media only screen and (max-width: 600px) {
  .editIcon{
    color: #727891;
  }
}
</style>

